import { withSvgProps } from './helpers'
import { ReactComponent as SvgComponent } from './svg/occupational-disability-icon.svg'

type SvgProps = React.ComponentProps<typeof SvgComponent>

const Svg: React.FC<SvgProps> = (props) => <SvgComponent {...props} />

export const OccupationalDisabilityIcon = withSvgProps(Svg)
